module.exports = "/_next/static/images/080d6068e2e9de9756b5af6c03f7e3ba-aboutus-xpeer.jpg.webp";